import { render, staticRenderFns } from "./BeliefCard.vue?vue&type=template&id=6fdc38ad&scoped=true&"
import script from "./BeliefCard.vue?vue&type=script&lang=js&"
export * from "./BeliefCard.vue?vue&type=script&lang=js&"
import style0 from "./BeliefCard.vue?vue&type=style&index=0&id=6fdc38ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdc38ad",
  null
  
)

export default component.exports